'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatabaseOperationException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when operation on the database failed
 */
let DatabaseOperationException = exports.DatabaseOperationException = function (_Exception) {
  _inherits(DatabaseOperationException, _Exception);

  /**
   * @param {String} error
   */
  function DatabaseOperationException(error) {
    _classCallCheck(this, DatabaseOperationException);

    return _possibleConstructorReturn(this, (DatabaseOperationException.__proto__ || Object.getPrototypeOf(DatabaseOperationException)).call(this, `Database operation failed. ${error}`, 500));
  }

  return DatabaseOperationException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Exception/DatabaseOperationException.js
// module id = 368
// module chunks = 0